import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ResourceColumn, ResourceListPage } from '../../components/resource/ResourceListPage';
import { ConsumoMadeira } from '../../types/producao';
import { consumoMadeiraService } from '../../services';

const columns: ResourceColumn<ConsumoMadeira>[] = [
  { header: "Ordem", accessor: "ordem_codigo" },
  { header: "Lote", accessor: "lote_info" },
  { header: "Quantidade (m³)", accessor: "quantidade_utilizada" },
  { header: "Perda", accessor: "perda_madeira" },
  { header: "Data", accessor: "data_consumo" }
];

export const ConsumoMadeiraListPage: React.FC = () => {
  const navigate = useNavigate();

  return (
  <ResourceListPage
    title="Consumo de madeira"
    description="Consumo de matéria-prima por ordem."
    columns={columns}
    service={consumoMadeiraService}
    createPath="/admin/producao/consumo-madeira/novo"
      onEdit={(item) => item.id && navigate("/admin/producao/consumo-madeira/editar", { state: { record: item } })}
  />
  );
};